// This file is autogenerated. Any changes will be overwritten.

export const set = 'budicon';

export const name = 'bolt';

export const Component = () => (
  <path d='M14.776 6.848 18.224 0h-8.86L4 12.74h7.327L6.921 24.52 21.624 6.848h-6.848ZM13.29 7.854h6.37L9.89 19.635l2.92-7.855H5.437L10.369.957h6.37l-3.45 6.897h.002Z' />
);

export const viewBox = '0 0 25 25';
